/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { spendRulesEventsList } from "../funcs/spendRulesEventsList.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListSpendRuleEventsResult } from "../models/components/listspendruleeventsresult.js";
import {
  EventType,
  ListSpendRuleEventsRequest,
  ListSpendRuleEventsSecurity,
} from "../models/operations/listspendruleevents.js";
import { unwrapAsync } from "../types/fp.js";
export type SpendRulesListEventsQueryData = ListSpendRuleEventsResult;

export function prefetchSpendRulesListEvents(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListSpendRuleEventsRequest | undefined,
  security?: ListSpendRuleEventsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildSpendRulesListEventsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildSpendRulesListEventsQuery(
  client$: GramCore,
  request?: ListSpendRuleEventsRequest | undefined,
  security?: ListSpendRuleEventsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<SpendRulesListEventsQueryData>;
} {
  return {
    queryKey: queryKeySpendRulesListEvents({
      ruleId: request?.ruleId,
      eventType: request?.eventType,
      cursor: request?.cursor,
      limit: request?.limit,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
      gramProject: request?.gramProject,
    }),
    queryFn: async function spendRulesListEventsQueryFn(
      ctx,
    ): Promise<SpendRulesListEventsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(spendRulesEventsList(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeySpendRulesListEvents(
  parameters: {
    ruleId?: string | undefined;
    eventType?: EventType | undefined;
    cursor?: string | undefined;
    limit?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
    gramProject?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "events", "list", parameters];
}
